import { getPreferredBookmaker } from "../components/lib/oddsGames";

export const BET_SLIP_INDEX = 0;

export function buildSelectionCheckId(
  gameId,
  bookmakerIndex,
  marketIndex,
  outcomeIndex
) {
  return `${gameId}-${bookmakerIndex}-${marketIndex}-${outcomeIndex}`;
}

/** Locate preferred bookmaker market on a game object. */
export function findMarketInGame(game, marketKey) {
  const bookmakers = game?.bookmakers || [];
  const bookmaker = getPreferredBookmaker(bookmakers);
  if (!bookmaker) return null;

  const marketIndex = (bookmaker.markets || []).findIndex(
    (m) => m?.key === marketKey
  );
  if (marketIndex < 0) return null;

  const bookmakerIndex = bookmakers.indexOf(bookmaker);
  return {
    bookmaker,
    market: bookmaker.markets[marketIndex],
    marketIndex,
    bookmakerIndex: bookmakerIndex >= 0 ? bookmakerIndex : 0,
  };
}

/**
 * Build a slip item from a live/pre-game game + market outcome.
 * Mirrors staightBetPage handleChangeOnClickGame teamObj shape.
 */
export function buildSlipItemFromGameOutcome(game, marketKey, outcomeIndex) {
  const found = findMarketInGame(game, marketKey);
  if (!found?.market) return null;

  const { market, marketIndex, bookmakerIndex, bookmaker } = found;
  const outcome = market.outcomes?.[outcomeIndex];
  if (!outcome) return null;

  const totalsSide = String(outcome.name || "").toLowerCase();
  const selectionTeamName =
    market.key === "totals"
      ? totalsSide === "over"
        ? game.home_team
        : totalsSide === "under"
          ? game.away_team
          : outcome.name
      : outcome.name;

  return {
    teamName: selectionTeamName,
    homeTeam: game.home_team,
    awayTeam: game.away_team,
    type: market.key,
    price: outcome.price ?? "-",
    point: outcome.point ?? "-",
    pointType: market.key === "totals" ? outcome.name : "",
    bookMarkType: bookmaker.key,
    sport_key: game.sport_key,
    sport_title: game.sport_title,
    gameTime: game.commence_time,
    id: game.id,
    CheckId: buildSelectionCheckId(
      game.id,
      bookmakerIndex,
      marketIndex,
      outcomeIndex
    ),
  };
}

/** Whether a slip leg matches a board checkbox. */
export function isSlipItemSelected(slip, checkId, gameId) {
  if (!Array.isArray(slip)) return false;
  return slip.some((item) => item.CheckId === checkId && item.id === gameId);
}
